import React from 'react';
const audiences = ['Te interesa el crimen organizado real en América Latina', 'Seguiste el caso Marset en los medios y querés la historia completa', 'Te fascinan las crónicas de poder, fuga y caída', 'Querés entender cómo funciona el narcotráfico en países considerados tranquilos'];
export function AudienceSection() {
  return <section className="w-full py-20 md:py-24 px-4 bg-zinc-950" data-id="element-10">
      <div className="max-w-3xl mx-auto text-center" data-id="element-11">
        <h2 className="font-['Playfair_Display'] font-bold text-3xl md:text-4xl text-zinc-200 mb-12" data-id="element-12">
          ¿Para quién es este libro?
        </h2>

        <div className="space-y-6 text-left max-w-2xl mx-auto" data-id="element-13">
          {audiences.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-14">
              <span className="font-['Playfair_Display'] text-xl text-[#C5A014] flex-shrink-0 mt-0.5" data-id="element-15">
                ✓
              </span>
              <p className="font-['Crimson_Text'] text-lg md:text-xl text-zinc-300 leading-relaxed" data-id="element-16">
                {item}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}